var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20C39 25.0391 36.9982 29.8718 33.435 33.435C29.8718 36.9982 25.0391 39 20 39C14.9609 39 10.1282 36.9982 6.56497 33.435C3.00178 29.8718 1 25.0391 1 20M39 20C39 14.9609 36.9982 10.1282 33.435 6.56497C29.8718 3.00178 25.0391 1 20 1C14.9609 1 10.1282 3.00178 6.56497 6.56497C3.00178 10.1282 1 14.9609 1 20M39 20H1",
    stroke: "#FF9515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3076 20C26.9487 26.9481 24.3895 33.6021 20 39C15.6104 33.6021 13.0512 26.9481 12.6923 20C13.0512 13.0519 15.6104 6.39791 20 1C24.3895 6.39791 26.9487 13.0519 27.3076 20Z",
    stroke: "#FF9515",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.c1ee0943f17c0d0f1b233a36a30cd6cd.svg";
export { ForwardRef as ReactComponent };